<template>
  <ipo3-page>
    <template slot="title">爬蟲清單</template>
    <template slot="tools">
      <el-input v-model="form.title" style="width:200px;margin-right:10px;" placeholder="請輸入標題"></el-input>
      <el-date-picker
      v-model="form.date"
      type="daterange"
      format="yyyy-MM-dd"
      range-separator="至"
      start-placeholder="開始日期"
      end-placeholder="結束日期" style="margin-right:10px;">
    </el-date-picker>
      <el-select v-model="form.source" placeholder="請選擇來源" style="margin-right:10px;">
              <el-option
                v-for="item in sources"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
      </el-select>
      
      <el-button icon="el-icon-edit" @click="onSearch" type="primary">搜索</el-button>
    </template>
    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <template v-for="item in items">
            <el-table-column
              :key="item.name"
              v-if="item.id==='image'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                <img :src="scope.row.image" width="100" height="100" />
              </template>
            </el-table-column>

            <el-table-column
              :key="item.name"
              v-else-if="item.scope==='time'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                  {{scope.row.update_at|formDate(true)}}
               </template>
            </el-table-column>

            <el-table-column
              v-else
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope">
              <div>
                <el-button
                  @click="onHandle(scope.$index, scope.row)"
                  size="mini"
                  type="success"
                  
                >審核</el-button>
                <el-button
                  @click="onDelete(scope.row)"
                  size="mini"
                  type="danger"
                >查看</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
    </template>
  </ipo3-page>
</template>
<script>
import axios from 'axios'
import {formatDate} from '@/filters'
export default {
  name: "news-index",
  data() {
    return {
      tableData: [],
      isLoading: false,
      form:{
        source:'',
        title:'',
        date:''
      },
      sources:[
        {
          name:'全部',
          value:''
        },
        // {
        //   name:'香港電台 – 即時新聞',
        //   value:'rthk'
        // },
        // {
        //   name:'香港經濟日報 – 即時新聞',
        //   value:'hket',
        // },
        // {
        //   name:'明報 – 即時新聞',
        //   value:'mingpao',
        // },
        // {
        //   name:'星島 - 即時',
        //   value:'stheadline'
        // },
        // {
        //   name:'新聞 – 港聞',
        //   value:'now'
        // },
        // {
        //   name:'新聞 – 兩岸國際',
        //   value:'now2'
        // },
        // {
        //   name:'東網 – 港澳',
        //   value:'oncc1'
        // },
        // {
        //   name:'東網 – 兩岸',
        //   value:'oncc2'
        // },
        // {
        //   name:'東網 – 亞歐非',
        //   value:'oncc3'
        // },
        // {
        //   name:'東網 – 美洲',
        //   value:'oncc4'
        // },
        // {
        //   name:'巴士的報 – 政事',
        //   value:'bastillepost'
        // },
        //  {
        //   name:'社會事',
        //   value:'bastillepost_social'
        // },
        // {
        //   name:'香港01 – 港聞',
        //   value:'hk01'
        // },
        // {
        //   name:'香港01 – 國際',
        //   value:'hk01_world'
        // },
        // {
        //   name:'AM730',
        //   value:'am730'
        // },{
        //   name:'881903 news',
        //   value:'881903'
        // },
        // {
        //   name:'立場新聞 社會',
        //   value:'thestandnews'
        // },
        // {
        //   name:'立場新聞 政治',
        //   value:'thestandnews2'
        // },
        // {
        //   name:'香港文匯報 - 港聞',
        //   value:'wenweipo'
        // }
      ],
      getRowClass: {
        background: "#F2F2F2"
      },
      items: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "title" },
        { name: "來源", id: "source" },
        { name: "時間", id: "newsdate"},
      ],
      currentPage: 1,
      pagecount: 1,
      paginate: 20
    };
  },
  created(){
      let params = this.$route.query;
      this.currentPage = params.page||1;
      this.paginate = params.size||10;
      let start_time = params.start_time||0;
      let end_time = params.end_time||0;
      let title = params.title||'';
      let source = params.source||'';
      this.form.title = title;
      this.form.source = source;
      this.getSources();
      this.getData(this.currentPage,this.paginate,title,start_time,end_time,source);
  },
  methods:{
    getSources(){
      let self = this;
      this.$http.get('/admin/source/all').then(res=>{
        console.log("res:",res);
        
        self.sources = self.sources.concat(res.data);
      })
    },
      getData(page=1,size=20,title='',start=0,end=0,source=''){
        // if(start>0)
        // {
        //   start = formatDate(start*1000,'yyyy-MM-dd');
        // end = formatDate(end*1000,'yyyy-MM-dd');
        // }
        const _axios = axios.create({
        timeout: 10000
        });
        let self = this;
        _axios.get(`https://news365.com2.hk/?page=api/getting_list_api_v2&p=${page}&perpageshow=${size}&title=${title}&start_time=${start}&end_time=${end}&source=${source}`).then(res=>{
            console.log("res:",res);
            let {total,data} = res.data;
              self.pagecount = total;
            self.tableData =  data;
        })
      },
      onSearch(){
        this.currentPage = 0;
        this.paginate = 10;
        let params = Object.assign({},this.form);
        if(params.date)
        {
          params.start_time = params.date[0].getTime()/1000;
          params.end_time = params.date[1].getTime()/1000;
        }else{
          params.start_time =0;
          params.end_time = 0;
        }
        delete params.date;
        this.$router.push({path:'/reptile/nindex',query:{page:this.currentPage,size:this.paginate,...params}});
        this.getData(this.currentPage,this.paginate,params.title,params.start_time,params.end_time,params.source);
      },
      
      onHandle(index,value)
      {
          console.log("value:",value);
          this.$router.push({path:'/reptile/nedit',query:value})
      },
      handleSizeChange(size)
      {
        this.paginate = size;
        this.getData(1,size);
      },

      handleCurrentChange(val)
      {
        console.log('value:',val);
        let params = Object.assign({},this.form);
        if(params.date)
        {
          params.start_time = params.date[0].getTime()/1000;
          params.end_time = params.date[1].getTime()/1000;
        }else{
          params.start_time =0;
          params.end_time = 0;
        }
        delete params.date;
        this.$router.push({path:'/reptile/nindex',query:{page:val,size:this.paginate,...params}})
        this.getData(val,this.paginate,params.title,params.start_time,params.end_time,params.source);
      },
      onDelete(val)
      {
        window.open(val.link,'_blank');
        // window.location.href = val.href;
      }
  }
};
</script>